import { render } from "./PurchaseReturn.vue?vue&type=template&id=158aa01e&scoped=true"
import script from "./PurchaseReturn.vue?vue&type=script&lang=js"
export * from "./PurchaseReturn.vue?vue&type=script&lang=js"

import "./PurchaseReturn.vue?vue&type=style&index=0&id=158aa01e&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158aa01e"]])

export default __exports__